import apiClient from './apiClient';
import {
  DELETE_EVENT_MEDIA,
  GET_EVENT_MEDIA,
  REORDER_EVENT_MEDIA,
  UPLOAD_EVENT_MEDIA
} from '../constants/UriConstants';
import { EventMediaInterface, ReorderEventMediaItem } from '../types/EventSettingsInterface';

export const getEventMedia = (): Promise<EventMediaInterface[]> =>
  apiClient.get(GET_EVENT_MEDIA).then((response) => response.data);

// Backend expects multipart fields `images` (up to 10) and `video` (up to 1).
export const uploadEventMedia = (images: Blob[], video?: Blob | null): Promise<EventMediaInterface[]> => {
  const formData = new FormData();
  images?.forEach((image) => formData.append('images', image));
  if (video) {
    formData.append('video', video);
  }
  return apiClient
    .post(UPLOAD_EVENT_MEDIA, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => response.data);
};

// Full-snapshot reorder — send every item with its new listOrder.
export const reorderEventMedia = (items: ReorderEventMediaItem[]): Promise<void> =>
  apiClient.put(REORDER_EVENT_MEDIA, { items }).then((response) => response.data);

export const deleteEventMedia = (eventMediaID: number): Promise<void> =>
  apiClient.delete(`${DELETE_EVENT_MEDIA}${eventMediaID}`).then((response) => response.data);
